import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RegisterComponent } from '../register/register.component';
import { RegisterTokenComponent } from '../register-token/register-token.component';

@Component({
  selector: 'umkt-register-wrapper',
  standalone: true,
  imports: [CommonModule, RegisterComponent, RegisterTokenComponent],
  templateUrl: './register-wrapper.component.html'
})
export class RegisterWrapperComponent implements OnInit {

  hasToken$!: Observable<boolean>;
  private route = inject(ActivatedRoute);


  ngOnInit(): void {
    this.hasToken$ = this.route.queryParams.pipe(
      map(params => !!params['token']) 
    );
  }
}
